import { IUser } from "@cruisen/contract"
import branchio from "branch-sdk"
import Config from "../config"

const publicBranchioKey = Config.branchKeyLive

export const generateAgentLink = (
  agentCode: string,
  loggedInUser: Omit<IUser, "updated" | "created">,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const branchData = {
      tripId: "",
      tripName: "",
      invitingUser: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
      invitingUserId: loggedInUser.id,
      referralCode: "",
      agentCode: agentCode,
    }

    branchio.init(publicBranchioKey, {}, () => {
      branchio.link(
        {
          data: branchData,
        },
        (err, link) => {
          if (err) {
            console.log("Error creating link", err)
            reject(err)
            return
          }
          console.log("link", link)
          resolve(link)
        },
      )
    })
  })
}
